import { ModalPrompt, Text } from "@repo/skapa";
import { t } from "@repo/translation";

interface ConfirmModalProps {
  visible: boolean;
  onClose: () => void;
  onConfirm: () => void;
  onCancel: () => void;
  title: string;
  message: string;
}
export const ConfirmModal = ({
  visible,
  onClose,
  onConfirm,
  onCancel,
  title,
  message,
}: ConfirmModalProps) => (
  <ModalPrompt
    titleId="confirm-modal-title"
    visible={visible}
    onClose={onClose}
    title={title}
    primaryButtonProps={{
      text: t("label.yes"),
      onClick: () => {
        onConfirm();
        onClose();
      },
    }}
    secondaryButtonProps={{
      text: t("label.no"),
      onClick: () => {
        onCancel();
        onClose();
      },
    }}
  >
    <Text>{message}</Text>
  </ModalPrompt>
);
